require('./bootstrap');

import Alpine from 'alpinejs'
import intersect from '@alpinejs/intersect'
import persist from '@alpinejs/persist'

import '@algolia/autocomplete-theme-classic';

import { startAutocomplete } from './autocomplete';
import { search } from './instantsearch';

window.Alpine = Alpine
Alpine.plugin(intersect)
Alpine.plugin(persist)
Alpine.start()

search.start();
if(document.getElementById('autocomplete-desktop')){
    startAutocomplete(search, '#autocomplete-desktop');
}
if(document.getElementById('autocomplete-mobile')){
    startAutocomplete(search, '#autocomplete-mobile');
}